import script from "./ModulesFeedbackView.vue?vue&type=script&setup=true&lang=js"
export * from "./ModulesFeedbackView.vue?vue&type=script&setup=true&lang=js"

import "./ModulesFeedbackView.vue?vue&type=style&index=0&id=32800b1a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32800b1a"]])

export default __exports__